import * as React from 'react';
import { useContext, useState } from 'react';
import { View } from 'react-native';
import {
  Appbar, BottomNavigation, Button, Searchbar,
} from 'react-native-paper';
import { useQuery } from '@apollo/client';
import { AuthContext } from '../../../context/AuthContext';
import { AllUsersQuery } from '../../../gql/user/query';
import { GET_CURRENT_SEASON } from '../../../gql/season/query';
import useDesktopLayout from '../../../hooks/useDesktopLayout';
import CompetitorsTab from './CompetitorsTab';
import CompanionsTab from './CompanionsTab';
import CoachesTab from './CoachesTab';
import DriversTab from './DriversTab';
import SuperAdminsTab from './SuperAdminsTab';

function ManageUsersTabs() {
  const { authState } = useContext(AuthContext);
  const isSuperAdmin = authState.role === 'SUPERADMIN';
  const isDesktop = useDesktopLayout();

  const [index, setIndex] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');

  const { data, loading, refetch } = useQuery(AllUsersQuery);
  const { data: dataSeason } = useQuery(GET_CURRENT_SEASON);

  const users = data?.allUsers ?? [];
  const season = dataSeason?.findCurrentSeason;

  const [routes] = useState(() => {
    const base = [
      { key: 'competitors', title: 'Compétiteurs', focusedIcon: 'karate', unfocusedIcon: 'karate' },
      { key: 'companions', title: 'Accompagnateurs', focusedIcon: 'account-heart', unfocusedIcon: 'account-heart-outline' },
      { key: 'coaches', title: 'Coachs', focusedIcon: 'account-hard-hat', unfocusedIcon: 'account-hard-hat' },
    ];
    if (isSuperAdmin) {
      base.push(
        { key: 'drivers', title: 'Conducteurs', focusedIcon: 'car', unfocusedIcon: 'car-outline' },
        { key: 'superadmins', title: 'Admins', focusedIcon: 'crown', unfocusedIcon: 'crown-outline' },
      );
    }
    return base;
  });

  const renderScene = ({ route }) => {
    switch (route.key) {
      case 'competitors':
        return <CompetitorsTab users={users} season={season} searchQuery={searchQuery} loading={loading} refetch={refetch} />;
      case 'companions':
        return <CompanionsTab users={users} searchQuery={searchQuery} loading={loading} refetch={refetch} />;
      case 'coaches':
        return <CoachesTab users={users} searchQuery={searchQuery} loading={loading} refetch={refetch} />;
      case 'drivers':
        return <DriversTab users={users} searchQuery={searchQuery} loading={loading} />;
      case 'superadmins':
        return <SuperAdminsTab users={users} searchQuery={searchQuery} loading={loading} />;
      default:
        return null;
    }
  };

  if (isDesktop) {
    return (
      <View style={{ flex: 1 }}>
        <Appbar.Header statusBarHeight={0}>
          <View style={{
            flex: 1, flexDirection: 'row', alignItems: 'center', paddingHorizontal: 8, gap: 8,
          }}
          >
            {routes.map((route, i) => (
              <Button
                key={route.key}
                mode={i === index ? 'contained-tonal' : 'text'}
                icon={i === index ? route.focusedIcon : route.unfocusedIcon}
                onPress={() => setIndex(i)}
              >
                {route.title}
              </Button>
            ))}
          </View>
          <Searchbar
            placeholder="Rechercher un utilisateur"
            onChangeText={(v) => setSearchQuery(v?.toLowerCase())}
            value={searchQuery}
            style={{ maxWidth: 480, marginHorizontal: 8 }}
          />
        </Appbar.Header>
        <View style={{
          flex: 1, width: '100%', maxWidth: 1400, alignSelf: 'center',
        }}
        >
          {renderScene({ route: routes[index] })}
        </View>
      </View>
    );
  }

  return (
    <View style={{ flex: 1 }}>
      <Appbar.Header statusBarHeight={0}>
        <Searchbar
          placeholder="Rechercher un utilisateur"
          onChangeText={(v) => setSearchQuery(v?.toLowerCase())}
          value={searchQuery}
          style={{ flex: 1, marginHorizontal: 8 }}
        />
      </Appbar.Header>
      <View style={{ flex: 1 }}>
        <BottomNavigation
          navigationState={{ index, routes }}
          onIndexChange={setIndex}
          renderScene={renderScene}
        />
      </View>
    </View>
  );
}

export default ManageUsersTabs;
